import { z } from 'zod';
import { ROLES } from '../constants.js';

// ─── Base shapes ─────────────────────────────────────────────────────────────

const roleSchema = z.enum(ROLES);
const userStatusSchema = z.enum(['active', 'inactive']);

// ─── Request schemas ──────────────────────────────────────────────────────────

export const CreateUserRequestSchema = z.object({
  email: z.string().email().toLowerCase(),
  name: z.string().min(1).max(200),
  role: roleSchema,
});
export type CreateUserRequest = z.infer<typeof CreateUserRequestSchema>;

export const UpdateUserRequestSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  role: roleSchema.optional(),
  status: userStatusSchema.optional(),
});
export type UpdateUserRequest = z.infer<typeof UpdateUserRequestSchema>;

export const ResetPasswordRequestSchema = z.object({
  // No body required — server generates the temp password
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

// ─── Response schemas ─────────────────────────────────────────────────────────

export const UserResponseSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: roleSchema,
  status: userStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
  lastLoginAt: z.string().nullable(),
});
export type UserResponse = z.infer<typeof UserResponseSchema>;

export const ListUsersResponseSchema = z.object({
  ok: z.literal(true),
  items: z.array(UserResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});
export type ListUsersResponse = z.infer<typeof ListUsersResponseSchema>;

export const ListUsersQuerySchema = z.object({
  status: userStatusSchema.optional(),
  role: roleSchema.optional(),
  limit: z.coerce.number().int().positive().max(200).default(50),
  offset: z.coerce.number().int().nonnegative().default(0),
});
export type ListUsersQuery = z.infer<typeof ListUsersQuerySchema>;
